export enum ServingScope {
  ONLY_THIS = "ONLY_THIS",
  ALL = "ALL",
}
